import { request } from "@/plugins/axios";
import qs from 'qs';
export default {
	//get
	'get': (url, data,durl) =>request({
        url: (durl==undefined?"":process.env.VUE_APP_CHAT_API)+"/api/"+url,
        method: 'GET',
        params:(data)
    }),
	//post
	"post": (url, data,durl) =>request({
        url: (durl==undefined?"":process.env.VUE_APP_CHAT_API)+"/api/"+url,
        method: 'post',
        data:qs.stringify(data)
    }),
	"post2": (url, data,durl) =>{
        let config = {
            url: url,
            method: 'post',
            data:qs.stringify(data)
        }
        if(durl && process.env.VUE_APP_CHAT_API) config.baseURL = process.env.VUE_APP_CHAT_API
        return request(config)
    },
}
